export default __webpack_public_path__ + "static/media/4793.bd14fadc.png";